import React from "react";
import {unstable_batchedUpdates} from 'react-dom';
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import debounce from "lodash.debounce";

import "./calendar.scss";

interface calendarInterface {
  setdate?: any;
  event?: any;
  sethour?: any;
  setactualYear?: any;
  setactualMonth?: any;
  specialistName?: any;
  setHoursEmpty?: any;
}

const calendar = (props: calendarInterface) => {
  const {
    setdate,
    event,
    sethour,
    setactualYear,
    setactualMonth,
    specialistName,
    setHoursEmpty,
  } = props;

  const calendarRef = React.createRef();
  const deafultCalendar = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];

  const handleDateClick = (info) => {
    setdate(info.dateStr);
    setHoursEmpty("");
    sethour(hoursAvailables(info.dateStr));
  };

  const updateDate = debounce((dir) => {
    let calendarApi = calendarRef.current.getApi();
    if (dir === "next") calendarApi.next();
    if (dir === "prev") calendarApi.prev();

    unstable_batchedUpdates(()=>{
    setactualMonth(
      deafultCalendar.indexOf(
        calendarApi.currentDataManager.data.viewTitle.split(" ")[0]
      ) + 1
    );
    setactualYear(calendarApi.currentDataManager.data.viewTitle.split(" ")[2]);
    })
  }, 500);

  const makeEvent = () => {
    const aux = [];
    event &&
      event.data.map((el) => {
        if (el.times.length !== 0) {
          aux.push({
            start: el.day,
            display: "background",
          });
        }
      });

    return aux;
  };

  const hoursAvailables = (date) => {
    const found = event.data.find((el) => el.day === date);
    if (found && found.times !== undefined) {
      return found.times;
    }
    return null;
  };

  return (
    <div className="a-calendar">
      <div className="a-calendar__head">
        <span className="a-calendar__head__content">
          {`Agenda con ${specialistName}`}
        </span>
      </div>
      <div className="a-calendar__title"></div>
      {event && (
        <div className="a-calendar__content">
          <span
            className="a-calendar__content__prev icon-chevron-left"
            onClick={() => updateDate("prev")}
          />
          <span
            className="a-calendar__content__next icon-chevron-right"
            onClick={() => updateDate("next")}
          />

          <FullCalendar
            ref={calendarRef}
            plugins={[dayGridPlugin, interactionPlugin]}
            dateClick={(info) => handleDateClick(info)}
            aspectRatio={10}
            height={350}
            headerToolbar={{
              start: "",
              end: "title",
            }}
            locale={"esLocale"}
            events={{
              events: makeEvent(),
            }}
            selectable={true}
            select={(info) => console.log(info)}
          />

          <div className="a-calendar__content__footer">
            <span className="a-calendar__content__footer__square icon-square1"></span>
            <span className="a-calendar__content__footer__title">
              Horarios Disponibles
            </span>
            <p className="a-calendar__content__footer__subtitle">
              Todas las horas corresponden a la zona horaria (UTC-05:00) Bogotá,
              Lima, Quito
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default calendar;
